import { render } from "./ja.vue?vue&type=template&id=49de3dc2&scoped=true&ts=true"
import script from "./ja.vue?vue&type=script&lang=ts"
export * from "./ja.vue?vue&type=script&lang=ts"

import "./ja.vue?vue&type=style&index=0&id=49de3dc2&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49de3dc2"]])

export default __exports__